import { mapState } from 'vuex'
import config from '@/config'
import moment from 'moment'

export default {
  props: {
    showInfo: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showSearchIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      zone: ''
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'region']),
    price() {
      let p = (this.dyna && this.dyna.LastPrice) || 0
      return this.isUsa() ? p.toFixed(3) : p.toFixed(2)
    },
    updown() {
      let p = (this.dyna && this.dyna.Updown) || 0
      return (p * 100).toFixed(2) + '%'
    },
    showTime() {
      return moment(this.dyna.Time * 1000).format('MM-DD HH:mm:ss')
    }
  },
  mounted() {
    if (this.region === 'USA') {
      this.zone = '美东'
    }
  },
  filters: {
    getStatus(type, region) {
      return config.marketStatus[region === 'CN' ? 'CN' : 'GMG'][type]
    },
    subStr(val) {
      if (val && val.length > 10) return `${val.substring(0, 10)}...`
      return val
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: `/${this.market}/${this.code}.html`,
      })
    },
    isUsa() {
      return this.zone === '美东'
    },
    getCode(val) {
      return this.region === 'HK' && /\d+/.test(val) ? '0' + val : val
    }
  }
}